export const summaryRows: string[] = [
  'Volume 01 — Fiber Optic Fundamentals: Fiber Types, Fusion Splicing, Connectors, OTDR & Testing',
  'Volume 02 — Structured Cabling Systems: Copper & Fiber, Racks, Pathways, Testing & Documentation',
  'Volume 03 — FTTH & PON Access Networks: GPON, XGS-PON, Splitters, ODN Design & Installation',
  'Volume 04 — Radio Links & Microwave Transmission: Propagation, Antennas, Link Budgets & Alignment',
  'Volume 05 — Towers & Cellular Sites: Site Types, RAN Equipment, Antennas, Power, Grounding & Installation',
  'Volume 06 — Network Operations & Maintenance: NOC, Fault Management, Preventive Maintenance & Troubleshooting',
  'Bonus 1 — Fiber Loss Budget & OTDR Trace Quick-Reference Cards',
  'Bonus 2 — Fiber Color Codes, Connectors & Cable Identification Cheat Sheets',
  'Bonus 3 — Field Installation & Inspection Checklists for Fiber, Cabling & Cell Sites',
  'Bonus 4 — How to Read Network Drawings, Splice Diagrams & As-Built Records',
  'Bonus 5 — Telecommunications & Fiber Optic Terminology Dictionary',
  '7-day money-back guarantee',
  'Instant access',
];
